import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    inject,
    signal,
    Signal,
    viewChild
} from '@angular/core';
import {NgClass} from "@angular/common";
import {QuantityListingComponent} from "./quantity-listing/quantity-listing.component";
import {TranslatePipe} from "@ngx-translate/core";
import {LamelareaStore} from "../../shared/product-card/product-card/lamelarea.store";
import {ProjectStore} from "../../shared/store/project.store";
import {MatDialog} from "@angular/material/dialog";
import {LoaderElementComponent} from "../../shared/loader-element/loader-element.component";
import {QuotationFormComponent} from "../../shared/modals/quotation-form/quotation-form.component";
import {MessageViewComponent} from "../../shared/modals/message-view/message-view.component";
import {PrintService} from "../print.service";
import {
    InterestedInQuotationComponent
} from "../../shared/modals/interested-in-quotation/interested-in-quotation.component";

@Component({
    selector: 'info-area',
    standalone: true,
    imports: [
        NgClass,
        QuantityListingComponent,
        TranslatePipe
    ],
    templateUrl: './info-area.component.html',
    styleUrl: './info-area.component.scss'
})
export class InfoAreaComponent {
    private readonly matDialog = inject(MatDialog);
    private readonly project = inject(ProjectStore);
    //apply dynamic key accessor
    [key:string]: any;

    printableArea: Signal<ElementRef> = viewChild("printableArea");

    private readonly printService = inject(PrintService);
    private readonly cd = inject(ChangeDetectorRef);

    private readonly infoArea: Signal<ElementRef> = viewChild('infoArea');

    protected showBillOfQuantitiesInfo: boolean = false;
    protected showPrintInfo: boolean = false;

    protected showPrintablePages = false;

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event): void {
        const targetElement = event.target as HTMLElement;
        if (!this.shouldIgnoreClick(targetElement)) {
            this.closeInfo();
            event.stopPropagation();
        }
    }

    @HostBinding('style.z-index')
    get zIndex(): number {
        return (this.showBillOfQuantitiesInfo || this.showPrintInfo) ? 100 : 10;
    }

    public toggleInfo(infoType: 'billOfQuantities' | 'print'): void {

        const mapping = {
            'billOfQuantities': 'showBillOfQuantitiesInfo',
            'print': 'showPrintInfo'
        };

        const currentInfo = mapping[infoType];
        const otherInfo = infoType === 'billOfQuantities' ? 'showPrintInfo' : 'showBillOfQuantitiesInfo';

        if (this[currentInfo] as boolean) {
            this.closeInfo();
        } else {
            this[currentInfo] = true;
            this[otherInfo] = false;
        }
    }

    protected async onRequestQuote(){
        return new Promise<boolean>((resolve)=>{
            this.matDialog.open(QuotationFormComponent, {
                data: { projectRecordId: this.project.projectRecord()?.id, withSave:true },
                minWidth: '40vw',
                enterAnimationDuration: '300ms',
                exitAnimationDuration: '300ms',
            })
                .afterClosed()
                .subscribe((data: Promise<boolean>)=>{

                    if(!data){
                        resolve(false);
                        return;
                    }

                    const loaderSignal = signal(true);

                    data?.then(()=> loaderSignal.set(false));

                    this.matDialog.open(LoaderElementComponent, { data: {
                            labelKey: "GLOBAL.LOADING",
                            loading: loaderSignal
                        },
                        enterAnimationDuration: '500ms',
                        exitAnimationDuration: '500ms',
                        disableClose: true,

                    }).afterClosed().subscribe(()=>
                        this.matDialog.open( MessageViewComponent, { data: {
                                translate: true,
                                message: "QUOTATION.QUOTATION_SUCCESS_MESSAGE"
                            },
                            enterAnimationDuration: '300ms',
                            exitAnimationDuration: '300ms',
                        }).afterClosed().subscribe(()=> resolve(true))
                    )

                    new Promise(()=>setTimeout(()=>loaderSignal && loaderSignal?.set(false),1000))
                });
        })
    }

    private closeInfo() {
        this.infoArea().nativeElement.style.width = '0%';
        setTimeout( () => {
            this.infoArea().nativeElement.style.width = null;
            this.showBillOfQuantitiesInfo = false;
            this.showPrintInfo = false;
        },1000);
        this.showPrintablePages = false;
    }

    private shouldIgnoreClick(targetElement: HTMLElement): boolean {
        return (
            targetElement.classList.contains('toggle-info-area-button') || //ignooraa kun klikkaus osuu infoAreaa kontrolloivaan nappiin
            (!this.showBillOfQuantitiesInfo && !this.showPrintInfo) || //ignooraa kun infoArea on jo suljettuna
            this.infoArea().nativeElement.contains(targetElement) //ignooraa kun klikkaus osuu infoArealle
        );
    }

     protected print(){

        const doPrint = ()=> {

            this.showPrintablePages = true;
            this.cd.detectChanges();

            if (this.printableArea) {
                this.printService.printElement(this.printableArea().nativeElement);
                this.showPrintablePages = false;
                this.cd.detectChanges();
            } else {
                console.error("Can't find printable area");
            }

        }

        this.isInterestedInQuotation().then((isInterested) => {
            isInterested
                ? this.onRequestQuote().then(doPrint)
                : doPrint();
        })

     }

     protected async isInterestedInQuotation(): Promise<boolean>{
        return new Promise<boolean>((resolve) =>
            this.matDialog.open(InterestedInQuotationComponent, {
            }).afterClosed().subscribe(resolve)
        )
     }


}
